export const businessesMonthlyStatesTask = state => state.businessesMonthlyStatesTask